import type { VariantProps } from "class-variance-authority";
import { cva } from "class-variance-authority";
import { type Component, splitProps } from "solid-js";
import { useI18n } from "@/api/i18n";
import { cn } from "@/libs/cn";
import { getMatchingVariant, type MatchingVariant } from "../utils/matching";

export const matchingBadgeVariants = cva(
  "inline-flex items-center rounded-md text-xs font-semibold px-2 py-0.5",
  {
    variants: {
      variant: {
        green: "bg-green-500/10 text-green-700",
        blue: "bg-blue-500/10 text-blue-700",
        yellow: "bg-amber-400/20 text-amber-800",
        orange: "bg-orange-500/20 text-orange-800",
      },
    },
    defaultVariants: {
      variant: "green",
    },
  },
);

export type MatchingBadgeProps = VariantProps<typeof matchingBadgeVariants> & {
  score: number;
  class?: string;
};

export const MatchingBadge: Component<MatchingBadgeProps> = (props) => {
  const { t } = useI18n();
  const [local, rest] = splitProps(props, ["score", "class", "variant"]);

  const variant = (): MatchingVariant =>
    local.variant ?? getMatchingVariant(local.score);
  const percent = () => Math.round(local.score);
  const label = () =>
    t("company.search.freelancers.result.match", {
      percent: String(percent()),
    });

  return (
    <span
      class={cn(matchingBadgeVariants({ variant: variant() }), local.class)}
      {...rest}
    >
      {label()}
    </span>
  );
};
